import React, { useState } from "react";
import { RiFileCopyLine, RiCheckLine } from "@remixicon/react";
import {
  SqTooltip,
  SqTooltipContent,
  SqTooltipTrigger,
} from "@/components/squircle-ui/tooltip";

interface CopyButtonProps {
  text: React.ReactNode;
  tooltipText?: {
    default: string;
    copied: string;
  };
  className?: string;
}

const CopyButton: React.FC<CopyButtonProps> = ({
  text,
  tooltipText = { default: "Copy name", copied: "Copied!" },
  className = "hidden group-hover:flex h-[20px] w-[20px] shrink-0 hover:bg-brand-orange/20 rounded-[4px] items-center justify-center text-brand-primary-400 hover:text-brand-orange cursor-pointer",
}) => {
  const [isCopied, setIsCopied] = useState(false);
  const [open, setOpen] = useState(false);

  const getTextValue = (): string => {
    if (typeof text === "string") return text;
    if (React.isValidElement(text) && "getValue" in text.props) {
      return String((text.props as { getValue: () => unknown }).getValue());
    }
    return JSON.stringify(text);
  };

  const handleCopy = () => {
    const textValue = getTextValue();
    void navigator.clipboard.writeText(textValue);
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  };

  return (
    <SqTooltip open={open} onOpenChange={setOpen}>
      <SqTooltipTrigger onMouseLeave={() => setOpen(false)} asChild>
        <button onClick={handleCopy} className={className}>
          {isCopied ? (
            <RiCheckLine size={14} className="text-inherit" />
          ) : (
            <RiFileCopyLine size={14} className="text-inherit" />
          )}
        </button>
      </SqTooltipTrigger>
      <SqTooltipContent onMouseEnter={() => setOpen(false)} side="bottom" align="start">
        {isCopied ? tooltipText.copied : tooltipText.default}
      </SqTooltipContent>
    </SqTooltip>
  );
};

export default CopyButton;
